import $ from "jquery";
import { Klass, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

/**
 * VuwFileThumbnail for VuwFileField
 * @options
 * - @required {string} dataType
 */
vuwer.appendKlass("VuwFileThumbnail", {
	_initialize: function _initialize(opt) {
		if( Klass("VuwFileThumbnail").parent._initialize.call(this, opt) ) {
			if(!this.dataType) {
				csl.warn.red(this.getAddress() + "._initialize() ... no dataType.");
				return false;
			}
			return this;
		} else {
			return false;
		}
	},
	
	render: function render($elm, state) {
		var src;
		if(state.src) {
			src = state.src;
			(/^data:/).test(src) || ( src += "?_=" + ( new Date() ).valueOf() );
			if(this.dataType === "img") {
				state.attr = {
					src: src,
					alt: "thumbnail"
				};
			} else
			if(this.dataType === "video") {
				state.attr = {
					src: src,
					preload: "metadata",
					controls: "controls"
				};
			}
			
			if(state.attr) {
				$elm = $("<" + this.dataType + "/>").attr(state.attr);
				delete state.attr;
			} else {
				$elm = $("<a/>").attr({
					href: src,
					target: "_blank"
				}).append( $("<span/>").text(state.fname || "登録済みのファイル") );
			}
			delete state.src;
			
		} else {
			$elm = $("<span/>");
			
			if(state.fname) {
				$elm.text(state.fname);
			} else {
				$elm.text("ファイルが選択されていません");
			}
		}
		
		return $elm;
	}
});
